import React from 'react';
import buttonStyles from 'assets/css/Button.module.css';
import styles from 'assets/css/ExamInfo.module.css';
import { IconAngleRight } from '@ace/react-icons';
import CardLink from 'Components/Card/CardLink';
import downArrowImg from 'assets/images/down-arrow-celeste.png';
import { RenderRawHTML } from '@ace/react-utilities';

function ExamInformationCard (props) {
    const { data } = props;
    return (
        <div className={styles.container}>
            <h4 className={styles.title}>
                {data.Title}
            </h4>

            <div className={styles.description}>
                {RenderRawHTML(data.BodyCopy)}
            </div>
            
            <CardLink
                linkText="Learn More"
                linkIcon={<IconAngleRight />}
                linkUrl={data.CallToAction}
                target="_blank"
                className={buttonStyles.floating}
            />

            <div className={styles.ctaWrap}>
                <img className={styles.ctaImg} src={downArrowImg} alt="Scroll Down" />

                <p className={styles.description}>
                    When you're ready, locate your Exam Options tile. Toggle between the exam types!
                </p>
            </div>
        </div>
    )
}

export default ExamInformationCard;
